import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat',
  standalone: false,
})
export class NumberFormatPipe implements PipeTransform {
  transform(item: string, locale = 'sv') {
    if (isNaN(item as unknown as number) || item === '') {
      return item;
    }
    return (+item).toLocaleString(locale).replace('−', '-');
  }
}
